module.exports = __webpack_public_path__ + "static/selfSeal-1e74f58d43d81c847a72087f99656ebe.gif";